import type { LogoBackgroundDto } from 'modules/core/domain/interfaces/supabase/organizer-logo-background/response-dto';
import { LogoBacking } from 'modules/organizer/domain/interfaces/logo-backing';

/**
 * Строка Supabase `organizer_logo_backing` → подложка логотипа. Из строки нужен только номер подложки: `id`,
 * `created_at` и `tournamentId` экрану не нужны. Строки нет (`null`) — подложка не задана; строка без `type` —
 * первая подложка набора, как и раньше читала форма профиля (`?? 0`).
 */
export function mapLogoBacking(dto: LogoBackgroundDto | null): LogoBacking | null {
  if (!dto) return null;
  return { type: dto.type ?? 0 };
}
